// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9ca58731","732":"c685ee54","977":"e4498cdd"}[chunkId] + ".chunk.js";
};